var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcWritingGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1768 4.70711C14.7863 4.31658 14.1531 4.31658 13.7626 4.70711L11.8968 6.57289L16.1854 10.8615L18.0512 8.99571C18.4417 8.60519 18.4417 7.97202 18.0512 7.5815L15.1768 4.70711ZM15.3277 11.7192L11.0391 7.43061L5.6418 12.8279C5.3037 13.166 5.09792 13.6141 5.06175 14.0908L4.8538 16.8317C4.80747 17.4424 5.31594 17.9509 5.92658 17.9045L8.66749 17.6966C9.14426 17.6604 9.5923 17.4546 9.9304 17.1165L15.3277 11.7192Z",
    fill: "#ABABAB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 19,
    width: 14,
    height: 1,
    fill: "#ABABAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWritingGray);
export default __webpack_public_path__ + "static/media/ic_writing_gray.6000dc204447f5dcfa95b34bf54c9e61.svg";
export { ForwardRef as ReactComponent };